import React, { useState, useEffect } from "react"
import "./PopulationOfTrialPreview.scss"
import { COUNTRIES } from "../../../../../RJS/schemas/dataSchemas/enum/enum"

const PopulationOfTrialPreview = (props) => {
  const [formData, setFormData] = useState([])
  const [totalWorldwide, setTotalWorldwide] = useState(0)
  const [totalEEA, setTotalEEA] = useState(0)

  let { formContext } = props

  let schema = {
    headers: [
      {
        key: "country_name",
        title: "Trial Country",
      },
      {
        key: "subjects",
        title: "Actual number of subjects enrolled",
      },
    ],
    footers: [
      {
        key: "worldwide",
        title: "Total: worldwide",
      },
      {
        key: "eea-only",
        title: "Total: EEA only",
      },
    ],
  }

  let eeaSet = new Set([
    "Belgium",
    "Bulgaria",
    "Czechia",
    "Czech Republic",
    "Denmark",
    "Cyprus",
    "Latvia",
    "Lithuania",
    "Luxembourg",
    "Spain",
    "France",
    "Croatia",
    "Italy",
    "Poland",
    "Portugal",
    "Romania",
    "Slovenia",
    "Hungary",
    "Malta",
    "Netherlands",
    "Austria",
    "Iceland",
    "Liechtenstein",
    "Norway",
    "Slovakia",
    "Finland",
    "Sweden",
    "Germany",
    "Estonia",
    "Ireland",
    "Greece",
    "United Kingdom",
  ])

  useEffect(() => {
    if (formContext?.formData?.results?.trial_info?.population?.country_subject_counts) {
      setFormData(formContext.formData.results.trial_info.population.country_subject_counts)
    }
  }, [formContext?.formData?.results?.trial_info?.population?.country_subject_counts])

  // auto calculate totals
  useEffect(() => {
    if (formData?.length > 0) {
      let totalWorldwide = 0
      let totalEEA = 0

      formData.forEach((country) => {
        totalWorldwide += Number(country.subjects)
        if (eeaSet.has(country.country_name)) {
          totalEEA += Number(country.subjects)
        }
      })

      setTotalWorldwide(totalWorldwide)
      setTotalEEA(totalEEA)
    }
  }, [formData])

  const displayRows = () => {
    return formData.map((country, i) => {
      let countryName = country.country_name
      let foundCountry = COUNTRIES.find((item) => item.value === countryName)
      if (foundCountry?.registries?.[formContext?.formView?.id]) {
        countryName = foundCountry.registries[formContext.formView.id]
      }
      return (
        <tr
          key={`trial-country-${i}`}
          className="population-trial-row"
        >
          <td className="population-trial-data ">{countryName}</td>
          <td className="population-trial-data ">{country.subjects}</td>
        </tr>
      )
    })
  }

  return (
    <div className="population-trial-container">
      <table>
        <thead>
          {schema.headers.map((header, i) => {
            let minWidth = 200
            return (
              <th
                key={`age-range-${header.key}`}
                style={{
                  minWidth: i === 0 ? 400 : minWidth,
                }}
                className="population-trial-table-heading"
              >
                {header.title}
              </th>
            )
          })}
        </thead>
        <tbody>
          {displayRows()}
          {schema.footers.map((footer, i) => {
            return (
              <tr
                className="population-trial-row"
                key={`${footer.title}-${i}`}
              >
                <td className="population-trial-data">{footer.title}</td>
                <td className="population-trial-data">
                  {footer.key === "worldwide" && totalWorldwide}
                  {footer.key === "eea-only" && totalEEA}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default PopulationOfTrialPreview
